<!--Mobile Header-->
<fgb-page-header [pageTitle]="'payment.success.page.title'"></fgb-page-header>

<div class="container d-flex align-items-center justify-content-center pt-5">
  <div class="wrap-box bg-secondary border border-grey rounded-4 text-center p-3">
    <div class="text-capitalize text-white fw-bold font-size-14">{{ 'purchase.success.heading' | translate }}</div>
    <hr class="line" />
    <div class="font-size-14 pb-3 text-white">
      {{ 'purchase.success.message' | translate }}
    </div>

    <button class="btn btn-primary px-lg-4 fw-bold text-white back-btn" routerLink="/guardians">
      {{ 'purchase.success.button' | translate }}
    </button>
  </div>
</div>
